import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Carousel } from "antd";
import { MyIcon } from "../../common/baseConfig";
import * as actions from './redux/actions';

import QuesPane from "./QuesPane"
export class ChapterPane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillReceiveProps(nextProps) {

    if (nextProps.quesStore.curQuesIndex !== this.props.quesStore.curQuesIndex) {
      this.refs.carousel.goTo(nextProps.quesStore.curQuesIndex);
    }
  }
  render() {
    let { fetchQuesCreateChapterSuccess, fontSize, checkParsIndex, curQuesIndex, } = this.props.quesStore;
    let Data = fetchQuesCreateChapterSuccess;
    if (!Data) return null;
    const { list, practiceId, resultId, } = Data;
    return (
      <div className="ques-store-chapter-pane">
        <div className="questionPane">
          <Carousel dots={false} ref="carousel" afterChange={(cur) => {
            this.props.actions.updateCurQuesIndex({ payload: cur })
          }}>
            {
              list.map((item, index) => (
                <QuesPane
                  key={item.ID}
                  data={item}
                  index={index}
                  fontSize={fontSize}
                  practiceId={practiceId}
                  resultId={resultId}
                  busType={1}
                  ExamModel={0}
                />
              ))
            }
          </Carousel>
        </div>
        <div className="checkAnalysisPane">
          <p className={curQuesIndex === 0 ? "prev-forbid" : "prev"} onClick={() => {
            if (curQuesIndex !== 0) {
              this.props.actions.updateCurQuesIndex({ payload: --curQuesIndex })
            }
          }}>
            <MyIcon type="iconwangzuo" className="icon" />
            <span>上一题</span>
          </p>
          <p className="check" onClick={() => {
            this.props.actions.updateCheckParsIndex({
              payload: checkParsIndex.add(list[curQuesIndex].ID)
            })
          }}>
            <MyIcon type="iconchakanjiexi" className="icon" />
            <span>查看解析</span>
          </p>
          <p className={curQuesIndex === list.length - 1 ? "next-forbid" : "next"} onClick={() => {
            if (curQuesIndex !== list.length - 1) {
              this.props.actions.updateCurQuesIndex({ payload: ++curQuesIndex })
            }
          }}>
            <span>下一题</span>
            <MyIcon type="iconwangyou-" className="icon" />
          </p>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChapterPane);



// WEBPACK FOOTER //
// ./src/features/ques-store/ChapterPane.js